import accounts from "./en/accounts.json" with { type: "json" };
import admin from "./en/admin.json" with { type: "json" };
import adminApp from "./en/admin-app.json" with { type: "json" };
import common from "./en/common.json" with { type: "json" };
import inventory from "./en/inventory.json" with { type: "json" };
import labels from "./en/labels.json" with { type: "json" };
import purchasing from "./en/purchasing.json" with { type: "json" };
import settings from "./en/settings.json" with { type: "json" };
import vehicleManagement from "./en/vehicle-management.json" with { type: "json" };
import vehicles from "./en/vehicles.json" with { type: "json" };
import work from "./en/work.json" with { type: "json" };

/**
 * The English strings, merged from the area files: the source every other language is checked
 * against, and the type of the web app's keys. Wording follows CONTEXT.md.
 */
export const en = {
  ...common,
  ...inventory,
  ...vehicles,
  ...work,
  ...purchasing,
  ...labels,
  ...settings,
  ...vehicleManagement,
  ...accounts,
  ...admin,
  ...adminApp,
};

export type Translation = typeof en;
